import { render, staticRenderFns } from "./DriverLeaveForm.vue?vue&type=template&id=86876e90"
import script from "./DriverLeaveForm.vue?vue&type=script&lang=js"
export * from "./DriverLeaveForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports